'use client';

import clsx from 'clsx';
import { forwardRef, useId, type InputHTMLAttributes, type ReactNode } from 'react';

import styles from './RadioInput.module.scss';

export interface RadioInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  /** Label content displayed next to the radio */
  label: ReactNode;
  /** Whether the radio input should take full width */
  fullWidth?: boolean;
}

export const RadioInput = forwardRef<HTMLInputElement, RadioInputProps>(
  ({ label, fullWidth = false, className, id: providedId, disabled, ...props }, ref) => {
    const generatedId = useId();
    const id = providedId || generatedId;

    return (
      <label
        htmlFor={id}
        className={clsx(
          styles.wrapper,
          { [styles.fullWidth]: fullWidth, [styles.disabled]: disabled },
          className
        )}
      >
        <input ref={ref} id={id} type="radio" disabled={disabled} {...props} />
        <span>{label}</span>
      </label>
    );
  }
);

RadioInput.displayName = 'RadioInput';
